// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import { navigationModeMenuStyles } from "@werner/Overrides/Components/NavigationModeMenu";
import CaretDown from "@werner/XDL/Icons/CaretDown";
import { color } from "@werner/XDL/Utilities";
import { css } from "styled-components";

navigationModeMenuStyles.navigationModeSelect = {
    css: css`
        &&&& {
            max-height: 40px;
            border: none;
            padding: 0 20px 0 10px;
            letter-spacing: 0.38px;
            line-height: 14px;
            font-size: 14px;
            font-weight: 500;
            border-radius: 0;
        }
    `,
    iconProps: {
        src: CaretDown,
        size: 10,
        color: "common.ui3",
        css: css`
            &&&& {
                border-radius: 0;
                width: 10px;
                height: 10px;
                padding: 0;
                top: 15px;
                right: 5px;
            }
        `,
    },
};

navigationModeMenuStyles.clickableStyles = {
    css: css`
        &&&&:hover {
            select,
            ${IconWrapper} {
                color: ${color("primary")};
            }
        }
    `,
};
